export default __webpack_public_path__ + "static/media/es.e3db1b5f.svg";